export const mutations = {
  addReseau (state, reseau) {
    state.reseau = reseau
  },
  setReseau (state, reseau) {
    state.reseau = reseau
  },
    addReseaux(state, reseaux){
    state.reseaux = [ ...reseaux ]
  },
  addReseauxPage(state, reseaux) {
    state.reseaux = reseaux
  }
}
